import PropTypes from 'prop-types';
import React from 'react';

import messageSchema from 'redux/schemas/messageSchema';
import { connect } from 'react-redux';
import Panel from 'components/Panel/Panel';
import { denormalize } from 'normalizr';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import InstructionBox from 'components/Shared/InstructionBox/InstructionBox';
import styles from './PendingPitchCounter.module.scss';

@connect(
  (
    {
      briefs2: briefs,
      entities: { messages: messageEntities, users: userEntities },
    },
    props
  ) => {
    const id = props.encodedId || (props.params && props.params.id);

    const {
      pendingPitches = [],
      PinderTabIsNew = true,
      totalPendingPitches,
    } = briefs[id];
    return {
      messageEntities,
      userEntities,
      pendingPitches,
      PinderTabIsNew,
      totalPendingPitches,
    };
  },
  {}
)
class PendingPitchCounter extends React.Component {
  static propTypes = {
    messageEntities: PropTypes.object,
    userEntities: PropTypes.object,
    brief: PropTypes.object,
    pendingPitches: PropTypes.array,
    totalPendingPitches: PropTypes.number,
    hideForMobile: PropTypes.bool,
    hideForDesktop: PropTypes.bool,
    PinderTabIsNew: PropTypes.bool,
    encodedId: PropTypes.string,
    params: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  getNewPitches = () => {
    const {
      messageEntities: messages,
      userEntities: users,
      pendingPitches: pitches,
    } = this.props;

    return denormalize(pitches, [messageSchema], {
      messages,
      users,
    }).filter(Boolean);
  };

  newPitchesMinusAvatarsCount = () => {
    const { totalPendingPitches } = this.props;

    if (totalPendingPitches > 3) {
      return `+${totalPendingPitches - 3}`;
    }
  };

  getAvatarGrid = () => {
    const { totalPendingPitches } = this.props;

    switch (totalPendingPitches) {
      case 0:
        return '';
      case 1:
        return styles.onePitchGrid;
      case 2:
        return styles.twoPitchesGrid;
      case 3:
        return styles.threePitchesGrid;
      default:
        return styles.morePitchesGrid;
    }
  };

  getPitchContainerRatio = () => {
    const { totalPendingPitches } = this.props;

    switch (totalPendingPitches) {
      case 0:
        return '';
      case 1:
        return styles.onePitchContainerRatio;
      case 2:
        return styles.twoPitchesContainerRatio;
      case 3:
        return styles.threePitchesContainerRatio;
      default:
        return styles.morePitchesContainerRatio;
    }
  };

  render() {
    const newPitches = this.getNewPitches();
    const {
      hideForMobile,
      hideForDesktop,
      PinderTabIsNew,
      totalPendingPitches,
    } = this.props;

    if (PinderTabIsNew && newPitches?.length > 0) {
      return (
        <Panel
          className={`${styles.counterDisplay} ${
            hideForMobile && `${styles.hideForMobile} box-shadow`
          } ${
            hideForDesktop &&
            styles.hideForDesktop + ' ' + this.getPitchContainerRatio()
          }`}
        >
          <div className={`${styles.avatarDisplay} ${this.getAvatarGrid()}`}>
            {newPitches?.map((pitch, index) => {
              if (index < 3) {
                return (
                  <Thumbnail
                    key={`pitcher avatars ${index}`}
                    thumbnails={pitch.sender.avatars}
                    className={styles.avatar}
                    circle
                  />
                );
              }
            })}
            <div>{this.newPitchesMinusAvatarsCount()}</div>
          </div>
          <div className={styles.textDisplay}>
            {totalPendingPitches} new applicant
            {totalPendingPitches > 1 ? 's' : ''} to view
            <InstructionBox
              panelStyle={{
                padding: '10px',
                marginTop: '10px',
                border: '3px solid gold',
              }}
              svgWidth={100}
              text={
                'Click 👎 Not interested to remove any applicants not relevant to your project.'
              }
              textStyle={{ fontSize: '14px' }}
            />
          </div>
        </Panel>
      );
    } else {
      return <noscript />;
    }
  }
}

export default PendingPitchCounter;
